

import firebase from 'firebase/compat/app';
import 'firebase/compat/database';

const firebaseConfig = {
    apiKey: "AIzaSyBJB2KIrngrrobGllOpWEnFgxUggqyJ7sI",
    authDomain: "trivia-maker.firebaseapp.com",
    databaseURL: "https://trivia-maker-tv.firebaseio.com",
    projectId: "trivia-maker",
    storageBucket: "trivia-maker.appspot.com",
    messagingSenderId: "275573147361"
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export default firebase;

